import { PayloadAction } from '@reduxjs/toolkit';
import { plantApi } from 'api/plantApi';
import { ListParams, plantInfo, ResponseData } from 'models';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { formatArrayAnalytics } from 'utils/common';
import { analyticsActions } from './analysisSlice';
// import { plantActions } from './plantSlice';

function* fetchDataOfPlantDetailAnalytics(action: PayloadAction<ListParams>) {
  const { id, time } = action.payload;
  try {
    const response: plantInfo = yield call(plantApi.fetchPlantInfo, { type: 'plant_id', id: id });
    if (response.system_size) {
      const responseOne: ResponseData[] = yield call(plantApi.fetchInfoPropertiesEnergy, {
        id: id,
        type: 'output-energy',
        properties: 'year',
        time: time,
      });
      const result = formatArrayAnalytics(responseOne, response.system_size);
      yield put(
        analyticsActions.fetchDataOfPlantDetailAnalyticsSuccess({
          ...result,
          label: response.label,
        })
      );
    }
  } catch (error) {
    yield put(
      analyticsActions.fetchDataOfPlantAnalyticsFailed('fetch Data Plant Analytics failed')
    );
  }
}

function* fetchDataOfPlantAnalytics(action: PayloadAction<ListParams>) {
  const { selectedItems, times } = action.payload;
  try {
    const callList = selectedItems.map((x: string) =>
      call(fetchDataOfPlantDetailAnalytics, {
        payload: { id: x, time: times },
        type: 'call',
      })
    );
    yield all(callList);
    yield put(analyticsActions.fetchDataOfPlantAnalyticsSuccess());
  } catch (error) {
    yield put(
      analyticsActions.fetchDataOfPlantAnalyticsFailed('fetch Data Plants Analytics failed')
    );
  }
}

export default function* analysisSaga() {
  yield takeLatest(analyticsActions.fetchDataOfPlantAnalytics, fetchDataOfPlantAnalytics);
}
